import {$api} from "./index";

export const fetchUsers = async () => {
    const {data} = await $api.get('api/user/all')
    return data
}

export const oneUser = async (id) => {
    const {data} = await $api.get('api/user/' + id)
    return data
}

export const updateUser = async (user) => {
    const {data} = await $api.put('api/user', user)
    return data
}

export const resetPassword = async (user) => {
    const {data} = await $api.put('api/user/reset', user)
    return data
}

export const deleteUser = async (id) => {
    const {data} = await $api.delete('api/user/' + id)
    return data
}